import React from 'react'
import './CreateAssetsForm.scss'

import { Grid, Typography, InputLabel } from '@material-ui/core'
import { FieldArray } from 'formik'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

import { InputField, SelectField, MultipleSelectField, CheckboxField } from '../../FormFields'
import { selector_entity_types, selector_entity_payload_types } from '../../../../config/constant'
import { Asset } from 'src/redux/reducers/assets'

function renderPayloadCheckbox(payload: Asset, platformAssetsIndex: number, payloadIndex: number) {
    if (payload['name'] && payload['type'] && payload['model']) {
        return (
            <CheckboxField
                className="PayloadCheckbox"
                name={`platform_assets[${platformAssetsIndex}].payload[${payloadIndex}]`}
                value={`${payload['name']}`}
                label={`${payload['name']}`}
            />
        )
    }
}

interface AreasArrayHelpers {
    push: any
    remove: any
    form: any
}

interface PayloadCheckboxProps {
    platformAssetsIndex: number
    payloadsArrayHelpers: AreasArrayHelpers
}

const PayloadCheckboxes = ({ platformAssetsIndex, payloadsArrayHelpers }: PayloadCheckboxProps) => {
    const { form } = payloadsArrayHelpers
    const { values } = form
    const { payload_assets } = values

    return (
        <>
            {payload_assets.map((payload: Asset, index: number) => (
                <div key={index}>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={6}>
                            {renderPayloadCheckbox(payload, platformAssetsIndex, index)}
                        </Grid>
                    </Grid>
                </div>
            ))}
        </>
    )
}

interface CreateAssetsFormProps {
    environmentData: any
    formField: any
}

function CreateAssetsForm(props: CreateAssetsFormProps) {
    const environments_names = props.environmentData

    const defaultValues_payload_assets = {
        name: '',
        type: '',
        model: '',
        position: { lat: '', lon: '', alt: '' },
        actions_orient: [],
        actions_look: [],
        actions_zoom: [],
        actions_get_detection: [],
    }

    const defaultValues_platform_assets = {
        name: '',
        type: '',
        model: '',
        position: { lat: '', lon: '', alt: '' },
        actions_goto: [],
        actions_neutralization: [],
        actions_get_telemetry: [],
        sparq_id: '',
        squad_id: '',
        payload: [],
    }

    return (
        <div className="CreateAssetsForm" data-test-id="usecase-create_assets_form">
            <React.Fragment>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <div>
                            <FieldArray name="payload_assets">
                                {(fieldArrayProps) => {
                                    const { push, remove, form } = fieldArrayProps
                                    const { values } = form
                                    const { payload_assets } = values

                                    if (payload_assets.length <= 0) {
                                        return (
                                            <div>
                                                <span className="ErrorMessage">Error: Payload Assets initial values are not present!</span>
                                            </div>
                                        )
                                    } else {
                                        if (
                                            // @ts-ignore 2025-05-23 ST - What's the point of this? Not sure this check does
                                            // what it's supposed to. Should be investigated.
                                            (!'name') in payload_assets[0] ||
                                            // @ts-ignore
                                            (!'type') in payload_assets[0] ||
                                            // @ts-ignore
                                            (!'model') in payload_assets[0] ||
                                            // @ts-ignore
                                            (!'position') in payload_assets[0]
                                        ) {
                                            return (
                                                <div>
                                                    <span className="ErrorMessage">
                                                        Error: payload Assets initial values object don't have the correct attributes!
                                                    </span>
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div>
                                                    <Typography variant="h6" gutterBottom>
                                                        Payload Asset
                                                    </Typography>
                                                    {payload_assets.map((_asset: any, index: number) => (
                                                        <div key={index}>
                                                            <br />
                                                            <Typography variant="subtitle1" gutterBottom>
                                                                Payload Asset {index + 1}
                                                            </Typography>
                                                            <br />
                                                            <InputLabel shrink>
                                                                Asset Name <span className="RequiredRed">*</span>
                                                            </InputLabel>
                                                            <InputField
                                                                type="text"
                                                                name={`payload_assets[${index}].name`}
                                                                fullWidth
                                                                data-test-id="usecase-create_assets_passet_name"
                                                            />
                                                            <br />
                                                            <br />
                                                            <InputLabel shrink>
                                                                Type <span className="RequiredRed">*</span>
                                                            </InputLabel>
                                                            <SelectField
                                                                name={`payload_assets[${index}].type`}
                                                                data={selector_entity_payload_types}
                                                                className="payload_type_select"
                                                                fullWidth
                                                            />
                                                            <br />
                                                            <br />
                                                            <InputLabel shrink>
                                                                Payload Model <span className="RequiredRed">*</span>
                                                            </InputLabel>
                                                            <InputField type="text" name={`payload_assets[${index}].model`} fullWidth />
                                                            <br />
                                                            <br />
                                                            <Typography variant="subtitle2" gutterBottom>
                                                                Action Environments
                                                            </Typography>
                                                            <Grid container spacing={3}>
                                                                <Grid item xs={4} sm={4}>
                                                                    <InputLabel shrink>Orient Sensor</InputLabel>
                                                                    <MultipleSelectField
                                                                        name={`payload_assets[${index}].actions_orient`}
                                                                        data={environments_names}
                                                                        className="payload_actions_orient_select"
                                                                        fullWidth
                                                                        multiple
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={4} sm={4}>
                                                                    <InputLabel shrink>Look At</InputLabel>
                                                                    <MultipleSelectField
                                                                        name={`payload_assets[${index}].actions_look`}
                                                                        data={environments_names}
                                                                        className="payload_actions_look_select"
                                                                        fullWidth
                                                                        multiple
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={4} sm={4}>
                                                                    <InputLabel shrink>Zoom</InputLabel>
                                                                    <MultipleSelectField
                                                                        name={`payload_assets[${index}].actions_zoom`}
                                                                        data={environments_names}
                                                                        className="payload_actions_zoom_select"
                                                                        fullWidth
                                                                        multiple
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={4} sm={4}>
                                                                    <InputLabel shrink>Get Detection</InputLabel>
                                                                    <MultipleSelectField
                                                                        name={`payload_assets[${index}].actions_get_detection`}
                                                                        data={environments_names}
                                                                        className="payload_actions_get_detection_select"
                                                                        fullWidth
                                                                        multiple
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            <br />
                                                            <Typography variant="subtitle2" gutterBottom>
                                                                Position
                                                            </Typography>
                                                            <Grid container spacing={3}>
                                                                <Grid item xs={4} sm={4}>
                                                                    <InputLabel shrink>Latitude</InputLabel>
                                                                    <InputField name={`payload_assets[${index}].position.lat`} fullWidth />
                                                                </Grid>
                                                                <Grid item xs={4} sm={4}>
                                                                    <InputLabel shrink>Longitude</InputLabel>
                                                                    <InputField name={`payload_assets[${index}].position.lon`} fullWidth />
                                                                </Grid>
                                                                <Grid item xs={4} sm={4}>
                                                                    <InputLabel shrink>Altitude (m)</InputLabel>
                                                                    <InputField name={`payload_assets[${index}].position.alt`} fullWidth />
                                                                </Grid>
                                                            </Grid>
                                                            {index > 0 && (
                                                                <button
                                                                    className="btn outline red RemoveButton"
                                                                    onClick={() => remove(index)}
                                                                    data-test-id="usecase-create_assets_remove_asset1"
                                                                >
                                                                    Remove Asset {payload_assets[index].name}
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}
                                                    <br />
                                                    <span className="AddButton" onClick={() => push(defaultValues_payload_assets)}>
                                                        <AddCircleOutlineIcon />
                                                        Add a payload Asset
                                                    </span>
                                                </div>
                                            )
                                        }
                                    }
                                }}
                            </FieldArray>
                        </div>
                    </Grid>
                </Grid>

                <br />
                <br />
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <div>
                            <FieldArray name="platform_assets">
                                {(fieldArrayProps) => {
                                    const { push, remove, form } = fieldArrayProps
                                    const { values } = form
                                    const { platform_assets } = values
                                    return (
                                        <div>
                                            <Typography variant="h6" gutterBottom>
                                                Platform Asset
                                            </Typography>
                                            {platform_assets.map((_asset: any, index: number) => (
                                                <div key={index}>
                                                    <br />
                                                    <Typography variant="subtitle1" gutterBottom>
                                                        Platform Asset {index + 1}
                                                    </Typography>
                                                    <br />
                                                    <InputLabel shrink>
                                                        Asset Name <span className="RequiredRed">*</span>
                                                    </InputLabel>
                                                    <InputField type="text" name={`platform_assets[${index}].name`} fullWidth />
                                                    <br />
                                                    <br />
                                                    <InputLabel shrink>
                                                        Type <span className="RequiredRed">*</span>
                                                    </InputLabel>
                                                    <SelectField
                                                        name={`platform_assets[${index}].type`}
                                                        data={selector_entity_types}
                                                        className="platform_type_select"
                                                        fullWidth
                                                    />
                                                    <br />
                                                    <br />
                                                    <InputLabel shrink>
                                                        Platform Model <span className="RequiredRed">*</span>
                                                    </InputLabel>
                                                    <InputField type="text" name={`platform_assets[${index}].model`} fullWidth />
                                                    <br />
                                                    <br />
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        Action Environments
                                                    </Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={6} sm={6}>
                                                            <InputLabel shrink>Go To</InputLabel>
                                                            <MultipleSelectField
                                                                name={`platform_assets[${index}].actions_goto`}
                                                                data={environments_names}
                                                                className="platform_actions_goto_select"
                                                                fullWidth
                                                                multiple
                                                            />
                                                        </Grid>
                                                        <Grid item xs={6} sm={6}>
                                                            <InputLabel shrink>Neutralization</InputLabel>
                                                            <MultipleSelectField
                                                                name={`platform_assets[${index}].actions_neutralization`}
                                                                data={environments_names}
                                                                className="platform_actions_neutralization_select"
                                                                fullWidth
                                                                multiple
                                                            />
                                                        </Grid>
                                                        <Grid item xs={6} sm={6}>
                                                            <InputLabel shrink>Get Telemetry</InputLabel>
                                                            <MultipleSelectField
                                                                name={`platform_assets[${index}].actions_get_telemetry`}
                                                                data={environments_names}
                                                                className="platform_actions_get_telemetry_select"
                                                                fullWidth
                                                                multiple
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <br />
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        Initial Position
                                                    </Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={4} sm={4}>
                                                            <InputLabel shrink>
                                                                Latitude <span className="RequiredRed">*</span>
                                                            </InputLabel>
                                                            <InputField name={`platform_assets[${index}].position.lat`} fullWidth />
                                                        </Grid>
                                                        <Grid item xs={4} sm={4}>
                                                            <InputLabel shrink>
                                                                Longitude <span className="RequiredRed">*</span>
                                                            </InputLabel>
                                                            <InputField name={`platform_assets[${index}].position.lon`} fullWidth />
                                                        </Grid>
                                                        <Grid item xs={4} sm={4}>
                                                            <InputLabel shrink>
                                                                Altitude (m) <span className="RequiredRed">*</span>
                                                            </InputLabel>
                                                            <InputField name={`platform_assets[${index}].position.alt`} fullWidth />
                                                        </Grid>
                                                    </Grid>
                                                    <br />
                                                    <InputLabel shrink>SPARQ</InputLabel>
                                                    <InputField type="text" name={`platform_assets[${index}].sparq_id`} fullWidth />
                                                    <br />
                                                    <br />
                                                    <InputLabel shrink>Squad ID</InputLabel>
                                                    <InputField type="text" name={`platform_assets[${index}].squad_id`} fullWidth />
                                                    <br />
                                                    <br />
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        Assign a Payload
                                                    </Typography>
                                                    <FieldArray name={`platform_assets[${index}].payload`}>
                                                        {(fieldArrayPlatformAssetsProps) => (
                                                            <>
                                                                <PayloadCheckboxes
                                                                    platformAssetsIndex={index}
                                                                    payloadsArrayHelpers={fieldArrayPlatformAssetsProps}
                                                                />
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                    {index > 0 && (
                                                        <button
                                                            className="btn outline red RemoveButton"
                                                            onClick={() => remove(index)}
                                                            data-test-id="usecase-create_assets_remove_asset2"
                                                        >
                                                            Remove Asset {platform_assets[index].name}
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                            <br />
                                            <span className="AddButton" onClick={() => push(defaultValues_platform_assets)}>
                                                <AddCircleOutlineIcon />
                                                Add a Platform Asset
                                            </span>
                                        </div>
                                    )
                                }}
                            </FieldArray>
                        </div>
                    </Grid>
                </Grid>
            </React.Fragment>
        </div>
    )
}

export default CreateAssetsForm
